import React from "react"
import ReactDOM from "react-dom"
import ImpressionHeroBlockComponent from "./impression-hero-block-component"

export default class ImpressionHeroBlock {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<ImpressionHeroBlockComponent {...this.modelJson} />, self.elem)
  }
}
